'use client'

import { BottomSheet } from '@fukku/dialog/BottomSheet/BottomSheet'
import { Content } from '@fukku/dialog/Content/Content'
import type { DialogAPI } from '@fukku/dialog/Dialog'
import { Header } from '@fukku/dialog/Header/Header'
import {
	SideSheet,
	type SideSheetProps,
} from '@fukku/dialog/SideSheet/SideSheet'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import dynamic from 'next/dynamic'
import type { ForwardRefExoticComponent, RefAttributes } from 'react'
import { useResponsiveBehavior } from 'responsive/hooks/useResponsiveBehavior/useResponsiveBehavior'

interface StoreLocatorModalProps {
	readonly storeLocatorModalRef: React.RefObject<DialogAPI | null>
}

const StoreLocatorContent = dynamic(() =>
	import('./StoreLocatorContent/StoreLocatorContent').then(
		(mod) => mod.StoreLocatorContent
	)
)

export const StoreLocatorModal = ({
	storeLocatorModalRef,
}: StoreLocatorModalProps) => {
	const { t } = useLabels()

	const ResponsiveDialog = useResponsiveBehavior<
		ForwardRefExoticComponent<SideSheetProps & RefAttributes<DialogAPI>>
	>({
		default: SideSheet,
		small: BottomSheet,
	})
	return (
		<ResponsiveDialog
			title={t('storeLocator.storeAvailabilty.title')}
			ref={storeLocatorModalRef}
			extraWidth
		>
			<Header title={t('storeLocator.search.title')} />
			<Content>
				<StoreLocatorContent />
			</Content>
		</ResponsiveDialog>
	)
}
